import React, { useEffect, useState, createContext } from 'react';
import { supabase, useTranslationsQuery, useUserQuery } from './app/api';
import {  compose as C, isNil, keys, mergeWith, or, path, prop as p, pickBy } from 'ramda';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { set_lang, set_missing, set_session, set_translations, set_user } from './app/ui_state';
import "./App.css"
import Auth from './app/Auth';
import Account from './app/Account';
import HeadingBar from './components/home';
import Decisions from './components/decisions';
import Decision from './components/decision';
import { LandingPage } from './components/landing';
import AdminLanding from './components/AdminLanding';

export const UserContext = createContext(); 

const App = () => {
  const session = useSelector(path(["ui","session"]));
  const dispatch = useDispatch();
  const location = useLocation();
  const {data:translations,isLoading} = useTranslationsQuery();
  const {data:user} = useUserQuery(session?.user?.id,{skip:!session?.user?.id});
  const lang = user?.lang || localStorage.getItem("lang") || "et";
  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      dispatch(set_session(session))});
    supabase.auth.onAuthStateChange((_event, session) => {
      dispatch(set_session(session))
    },[dispatch]);

    if (!isLoading && translations) {
      const missing = C(
        keys,
        pickBy(isNil),
        p(lang)
      )(translations)      
      dispatch(set_missing(missing));
      dispatch(set_translations(mergeWith(or,translations[lang],translations["et"])));
      dispatch(set_lang(lang));
    }
  }, [dispatch,translations,lang,isLoading]);


  return <>
    <UserContext.Provider value={session}>
      <main id="main">
        <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/app">
              <Route index  element={!session ? <Auth/> : <Decisions/>} ></Route>
              <Route path=":id" element={<Decision/>}></Route>
            </Route>
            <Route path="/konto" element={!session ? 
              <Auth/> : <Account key={session?.user?.id} session={session} />}>
            </Route>
            <Route path="/admin" element={!session ? <Auth/> : <AdminLanding session={session} />} />
          </Routes>
          <HeadingBar buttons={location.pathname !== "/"} />
      </main>
    </UserContext.Provider>
  </>;
};

export default App;
